import request, { METHODS } from "src/utils/api-base";

const salesOrderApis = {
  getSalesList: (params: {
    page: number;
    limit: number;
    createdBy?: string;
    customerId?: string;
    search?: string;
    orderStatus?: "pending" | "completed" | "cancelled";
    paymentStatus?: "paid" | "pending" | "cancelled";
  }) => {
    return request({
      route: "/app/sale-order/list",
      method: METHODS.GET,
      params,
      auth: true,
    });
  },

  createSalesOrder: (payload: any) => {
    return request({
      route: "/app/sale-order/create",
      method: METHODS.POST,
      payload,
      auth: true,
    });
  },

  getOrderById: (orderId: string) => {
    return request({
      route: `/app/sale-order/${orderId}`,
      method: METHODS.GET,
      auth: true,
    });
  },

  updateSalesOrder: (orderId: string, payload: any) => {
    return request({
      route: `/app/sale-order/${orderId}`,
      method: METHODS.PUT,
      payload,
      auth: true,
    });
  },

  completeSalesOrder: (orderId: string) => {
    return request({
      route: `/app/sale-order/${orderId}/complete`,
      method: METHODS.POST,
      auth: true,
    });
  },

  cancelSalesOrder: (orderId: string) => {
    return request({
      route: `/app/sale-order/${orderId}/cancel`,
      method: METHODS.POST,
      auth: true,
    });
  },
};

export default salesOrderApis;
